import {useCallback, useState, useEffect} from 'react'

export const useCard = () => {
    const [cardForm, setCardForm] = useState(null)
    const [homeConfirm, setHomeConfirm] = useState(null)
    const [pendingTarget, setPendingTarget] = useState(null)

    const createForm = useCallback((form)=> {
        const copyForm = JSON.stringify(form)
        setCardForm(JSON.parse(copyForm))
    }, [])

    useEffect(() => {
    }, [cardForm])

    return {createForm, cardForm, homeConfirm, setHomeConfirm, pendingTarget, setPendingTarget} 
}